import { ReactNode, useId } from "react";
import { FormattedMessage } from "react-intl";

import { HeaderBox } from "@/components/header-box";
import { RanaMap } from "@/lib/rana-map";
import { combineHccModelExtents } from "@/utils/schematisation-extents";

import { useSchematisationDetailsContext } from "../schematisation-details-context";

export function SchematisationPreview() {
  const { threediModel } = useSchematisationDetailsContext();
  const mapId = `schema-map-${useId()}`;
  const bounds = combineHccModelExtents(threediModel);
  let previewContent: ReactNode;

  if (!bounds) {
    previewContent = (
      <FormattedMessage
        id="schematisation.model_extent_not_available"
        defaultMessage="Model extent not available"
      />
    );
  } else {
    previewContent = (
      <RanaMap mapId={mapId} bounds={bounds} mapProps={{}}>
        <RanaMap.MapScale />
        <RanaMap.ExtentLayer bounds={bounds} />
      </RanaMap>
    );
  }

  return (
    <HeaderBox name={<FormattedMessage id="filepreview.preview" defaultMessage="Preview" />}>
      {previewContent}
    </HeaderBox>
  );
}
